module.exports = __webpack_public_path__ + "assets/img/asbes.78ff21a9.svg";